import { Navigate, useParams } from 'react-router-dom'

/**
 * Legacy `/biddle/:propertyId/:biddleId` deep links → current shell route with modal params.
 * Falls back to `/biddles` so the list is underneath the modal.
 */
export function BiddleDetailRedirect() {
  const { propertyId, biddleId } = useParams<{ propertyId: string; biddleId: string }>()
  if (!propertyId || !biddleId) return <Navigate to="/biddles" replace />
  const params = new URLSearchParams()
  params.set('biddle', biddleId)
  params.set('biddleProperty', propertyId)
  return <Navigate to={`/biddles?${params.toString()}`} replace />
}
